// // @ts-ignore
// import { RequestServiceResponseModel } from "../../Models/RequestSubject/RequestSubjectResponseModel.ts";
// import { CustomAlert } from "../../Utils/CustomModal/CustomModal";
// @ts-ignore
import { MethodsService, ServiceCaller } from "../BaseService.ts";

export default async function getRequestSubjectService(): Promise<any> {
  let serviceCall: ServiceCaller = new ServiceCaller();
  // let Temp: any;

  serviceCall.call(
    "request/get-request-subject-list",
    MethodsService.GET,
    null
  );
  return serviceCall.response;
}
